import { ChangeDetectionStrategy, Component, inject, input, model, output } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { AnagraficaIndirizziService } from 'src/app/core/anagrafica-indirizzi.service';
import { AnagraficheService } from 'src/app/core/anagrafiche.service';
import { DocumentoRiproduzioneRow } from 'src/app/shared/models/documentoRiproduzione.model';
import { Indirizzo } from 'src/app/shared/models/indirizzo.model';

@Component({
  selector: 'app-modifica-riproduzione-dialog',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
  @if (riproduzione(); as riproduzione) {
    <p-dialog header="Modifica Riproduzione" [(visible)]="visible" [modal]="true" (onHide)="hide.emit($event)" [style]="{width: '600px'}">
      <div>
        <label for="enteRichiedente" class="small-label">Ente Richiedente</label>
        <app-dati-documento-destinatari  id="enteRichiedente" ngDefaultControl [(ngModel)]="destinatariArray" (addIndirizzo)="addIndirizzo($event)"
          tooltipPosition="left" />
      </div>
      <div >
        <label for="originatore" class="small-label">Originatore</label>
        <input id="originatore" class="width-fill-available" pInputText type="text" [(ngModel)]="riproduzione.originatore" required>
      </div>
      <div >
        <label for="numeroPagine" class="small-label">Numero Pagine</label>
        <textarea pInputTextarea class="width-fill-available" id="numeroPagine"[(ngModel)]="riproduzione.numeroPagine" [rows]="5" [cols]="50" title="numeroPagine"
          maxlength="3000"></textarea>
      </div>
      <p-footer>
        <button pButton type="button" icon="pi pi-times" label="Annulla" (click)="hideDialog()"
          class="p-button-secondary"></button>
        <button [disabled]="!(destinatariArray()?.length !== 0)" pButton type="button" icon="pi pi-check" label="Modifica" (click)="modify_click()">
        </button>
      </p-footer>
    </p-dialog>
  }
  `,
  styles: [`
  label { margin-bottom: 4px; margin-top: 20px; color: inherit; }
  label:first-of-type { margin-top: 0; }
  .width-fill-available{ width: 100%; }
  `]
})

export class ModificaRiproduzioneDialogComponent {
  visible = model.required<boolean>();
  riproduzione = input<DocumentoRiproduzioneRow | undefined>();
  destinatariArray = model<Indirizzo[] | undefined>();
  hide = output();
  modify = output<{ riproduzione: DocumentoRiproduzioneRow, destinatari: Indirizzo[] }>();

  public AnagraficaIndirizziService = AnagraficaIndirizziService;

  private anagraficheService = inject(AnagraficheService);
  private confirmationService = inject(ConfirmationService);

  hideDialog(): void {
    this.hide.emit();
  }

  modify_click(): void {
    this.confirmationService.confirm({
      message: `Confermare le modifiche alla Riproduzione?`,
      acceptLabel: 'Conferma',
      accept: () => {
        this.modify.emit({ riproduzione: this.riproduzione()!, destinatari: this.destinatariArray()! });
        this.hideDialog();
      }
    });
  }

  addIndirizzo(name: string | null): void {
    if (name) {
      const ind = {
        isConfirmed: false,
        nomeIndirizzo: name
      } as Indirizzo;

      this.anagraficheService.indirizzi.create(ind).subscribe();
    }
  }
}
